<section class="leadership">
    <div class="section-name">
        <h6>
            LEADERSHIP
        </h6>
        <div class="line"></div>
    </div>
<div class="leadership-wrapper">
    <div class="row align-items-start">
        <div class="col-lg-6 col-sm-12">
            <div class="row align-items-start leadership-item">
                <div class="col-12 col-lg-4 text-center">
                    <img class="img-leader" src="../../../assets/about/CEO_Glenn_Transparent.png" alt="Glenn Summerfield">
                </div>
                <div class="col-12 col-lg-8" class="leadership-content">
                    <h4 class="name">Glenn Summerfield</h4>
                    <h5 class="position">President & CEO</h5>
                    <div class="leadership-info">
                        <p>Mr. Summerfield has over 30 years of management, efficiency analysis, design, development and marketing experience with several Fortune 500 firms as well as Federal, State, Local, and Foreign Government Agencies.  His experience as a Scientist and former U.S. Diplomat provides him with invaluable troubleshooting and negotiating skills.</p>
                        <p>He holds a Bachelor's degree in nuclear engineering and electronic engineering with an Associate's degree in computer science.</p>
                    </div>   
                </div>
            </div>
        </div>

        <div class="col-lg-6 col-sm-12">
            <div class="row align-items-start leadership-item">
                <div class="col-12 col-lg-4 text-center">
                    <img class="img-leader" src="../../../assets/about/CTO_Bryan_Transparent_190.png" alt="Bryan Bos">
                </div>
                <div class="col-12 col-lg-8" class="leadership-content">
                    <h4 class="name">Bryan Bos</h4>
                    <h5 class="position">Chief Technology Officer</h5>
                    <div class="leadership-info">
                        <p>Mr. Bos has over 20 years product architecture, design and development experience with some of the largest clients in the world. His forward thinking and ability to design/develop complex software applications in his head is an invaluable asset.</p>
                        <p>Born in Ontario, CA, Mr. Bos holds a Bachelor's degree in Computer Science.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row align-items-start">
        <div class="col-lg-6 col-sm-12">
            <div class="row align-items-start leadership-item">
                <div class="col-12 col-lg-4 text-center">
                    <img class="img-leader" src="../../../assets/about/CFO_Roger_Transparent_190.png" alt="Roger Osborn">
                </div>
                <div class="col-12 col-lg-8" class="leadership-content">
                    <h4 class="name">Roger Osborn</h4>
                    <h5 class="position">Chief Financial Officer</h5>
                    <div class="leadership-info">
                        <p>Mr. Osborn has more than 30 years of professional experience as a financial executive, tax consultant, and entrepreneur.  He has held leadership positions including tax manager at a national accounting firm and has also been a partner in a national investment banking firm.</p>
                        <p>Mr. Osborn has led capital structuring, acquisition initiatives, and negotiates with leading Wall Street investment banks to provide over $1billion in capital.</p>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="col-lg-6 col-sm-12">
            <div class="row align-items-start leadership-item">
                <div class="col-12 col-lg-4 text-center">
                    <img class="img-leader" src="../../../assets/about/CEBO_Andrew_Stepanenko.png" alt="Andrew Stepanenko">
                </div>
                <div class="col-12 col-lg-8" class="leadership-content">
                    <h4 class="name">Andrew Stepanenko</h4>
                    <h5 class="position">Chief European Business Officer</h5>
                    <div class="leadership-info">
                        <p>More than 20 years of experience in international business management, systems architecture, software design and development.  Mr. Stepanenko’s multifaceted responsibility has solidified him as a vital member of the team providing direction, product vision, and strategic leadership to facilitate and fuel corporate growth.</p>
                        <p>Mr. Stepanenko holds a Master’s degree with honors, and is pursuing his PhD in Computer Engineering.</p>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</div>
</section>
